import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  colors: {
    primary: {
      main: '#00B2FF',
      dark: '#0080B3',
      light: '#7FF1FF',
      gradient: 'linear-gradient(135deg, #00B2FF 0%, #7FF1FF 100%)'
    },
    secondary: {
      silver: '#E0E0E0',   // Prata da logo
      copper: '#CD7F32',   // Cobre da logo
      gold: '#FFD700'      // Dourado da logo
    },
    background: {
      light: '#1A1A1A',
      dark: '#121212',
      darker: '#0A0A0A',
      overlay: 'rgba(0, 178, 255, 0.03)'
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B3B3B3',
      highlight: '#7FF1FF',  // Para destaques
      dark: '#1A1A1A'
    },
    circuit: {
      line: '#00B2FF40',   // Para linhas de circuito decorativas
      dot: '#00B2FF'       // Para pontos de conexão
    }
  },
  spacing: {
    xs: '0.25rem',    // 4px
    sm: '0.5rem',     // 8px
    md: '1rem',       // 16px
    lg: '1.5rem',     // 24px
    xl: '2rem',       // 32px
    '2xl': '4rem'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    circle: '50%'
  },
  typography: {
    fontFamily: {
      heading: "'DM Sans', sans-serif",  // Fonte principal para títulos
      body: "'DM Sans', sans-serif"      // Fonte principal para textos
    },
    sizes: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      md: '1rem',       // 16px
      lg: '1.125rem',   // 18px
      xl: '1.25rem',    // 20px
      '2xl': '1.5rem',  // 24px
      '3xl': '2rem',    // 32px
      '4xl': '2.5rem',  // 40px
      '5xl': '3rem'     // 48px
    },
    lineHeight: {
      tight: '1.2',
      normal: '1.5',
      relaxed: '1.75'
    },
    weight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }
  },
  effects: {
    circuitPattern: `
      radial-gradient(circle at 100% 50%, transparent 20%, rgba(0, 178, 255, 0.03) 21%, rgba(0, 178, 255, 0.03) 34%, transparent 35%, transparent),
      radial-gradient(circle at 0% 50%, transparent 20%, rgba(0, 178, 255, 0.03) 21%, rgba(0, 178, 255, 0.03) 34%, transparent 35%, transparent)
    `,
    glow: `0 0 20px rgba(0, 178, 255, 0.1)`,
    glassMorphism: `
      background: rgba(26, 26, 26, 0.7);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(0, 178, 255, 0.1);
    `
  }
};

export type Theme = typeof theme;

const breakpoints = {
  xs: '320px',
  sm: '480px',
  md: '768px',  // Este é o ponto onde o menu mobile deve aparecer
  lg: '1024px',
  xl: '1200px'
};

const mediaQueries = {
  xs: `@media screen and (max-width: ${breakpoints.xs})`,
  sm: `@media screen and (max-width: ${breakpoints.sm})`,
  md: `@media screen and (max-width: ${breakpoints.md})`, // Este é o que estamos usando
  lg: `@media screen and (max-width: ${breakpoints.lg})`,
  xl: `@media screen and (max-width: ${breakpoints.xl})`
}; 